<app-customer-resume-bar [customer]="currentAccount"></app-customer-resume-bar>
@switch (type){
  @case (EnrollmentType.INDIVIDUAL_OWNER){
    <app-account-detail-individual-owner [account]="currentAccount" [selectedIndex]="activeTabIndex" (selectedTab)="onTabChange($event)"></app-account-detail-individual-owner>
  }
  @case (EnrollmentType.INDIVIDUAL_BED){
    <app-account-detail-individual-bed [account]="currentAccount" [selectedIndex]="activeTabIndex" (selectedTab)="onTabChange($event)"></app-account-detail-individual-bed>
  }
  @case (EnrollmentType.PROPERTY_MANAGEMENT){
    <app-account-detail-mgmt-company [account]="currentAccount" [selectedIndex]="activeTabIndex" (selectedTab)="onTabChange($event)"></app-account-detail-mgmt-company>
  }
}
@if (activeTabIndex === 0) {
  <div class="actions-bar">
    <div class="profile-buttons">
      <button class="go-back" type="button" mat-button (click)="exit()"><mat-icon
        [svgIcon]="icons.ArrowLeftIcon"></mat-icon>Go Back</button>
      <button class="continue" [disabled]="isLoading" type="submit" (click)="save()" mat-button>
        @if (isLoading) {
          <mat-spinner diameter="18"></mat-spinner>
        } @else {
          <mat-icon fontIcon="save"></mat-icon>
        }
        Save</button>
    </div>
  </div>
}
